export const ko = {
  // 네비게이션
  nav_home: "홈",
  nav_growth: "성장 기록",
  nav_statistics: "통계",
  nav_family: "가족설정",
  nav_backup: "백업",
  nav_add_memory: "추억 추가",
  nav_main_menu: "주요 메뉴",
  nav_photobook: "포토북 만들기",
  nav_family_settings: "가족 설정",
  nav_share: "공유",
  nav_memories: "추억 보기",
  nav_albums: "앨범",
  nav_invite: "가족 초대",
  nav_admin: "관리자",
  nav_activity_log: "활동 로그",
  nav_trash: "휴지통",
  nav_profile: "프로필",
  nav_login: "로그인",
  nav_logout: "로그아웃",
  
  // 사이트 공통
  site_title: "민호민아",
  language: "언어",
  
  // 인증
  auth_login: "로그인",
  auth_logout: "로그아웃",
  auth_signup: "회원가입",
  auth_account: "계정",
  
  // 로그인 페이지
  login: {
    title: "로그인",
    signupTitle: "회원가입",
    subtitle: "민호민아의 소중한 추억을 함께해요",
    name: "이름",
    namePlaceholder: "홍길동",
    email: "이메일",
    emailPlaceholder: "your@email.com",
    password: "비밀번호",
    passwordPlaceholder: "••••••••",
    confirmPassword: "비밀번호 확인",
    passwordMismatch: "비밀번호가 일치하지 않습니다.",
    passwordTooShort: "비밀번호는 최소 6자 이상이어야 합니다.",
    signupSuccess: "회원가입이 완료되었습니다! 이메일을 확인해주세요.",
    emailAlreadyExists: "이미 등록된 이메일입니다.",
    signupError: "회원가입 중 오류가 발생했습니다.",
    loginError: "이메일 또는 비밀번호가 올바르지 않습니다.",
    signingUp: "가입 중...",
    loggingIn: "로그인 중...",
    haveAccount: "이미 계정이 있으신가요?",
    noAccount: "계정이 없으신가요?",
    loginButton: "로그인",
    signupButton: "회원가입"
  },
  
  // 히어로 섹션
  hero_title: "민호와 민아의",
  hero_subtitle: "소중한 순간들",
  hero_description: "우리 아이들의 성장 이야기를 기록하고, 추억을 간직하며, 사랑을 나누는 공간입니다.",
  
  // 통계 카드
  stat_total_posts: "총 게시물",
  stat_photos: "사진",
  stat_videos: "동영상",
  stat_milestones: "기념일",
  
  // 필터 섹션
  filter_title: "추억 필터",
  filter_search_placeholder: "제목이나 설명으로 검색...",
  filter_age_view: "나이별 보기",
  filter_all: "전체",
  filter_tags: "태그 필터",
  filter_reset: "초기화",
  filter_slideshow: "슬라이드쇼",
  filter_photobook: "포토북 만들기",
  filter_all_people: "전체보기",
  filter_minho: "민호",
  filter_mina: "민아",
  filter_both: "민호민아",
  
  // 레이아웃
  layout_grid: "그리드",
  layout_masonry: "마소너리",
  layout_timeline: "타임라인",
  
  // 공통 메시지
  msg_loading: "로딩 중...",
  msg_no_data: "데이터가 없습니다",
  msg_error: "오류가 발생했습니다",
  msg_success: "성공적으로 완료되었습니다",
  no_memories: "추억이 없습니다.",
  
  // 버튼
  btn_save: "저장",
  btn_cancel: "취소",
  btn_edit: "편집",
  btn_delete: "삭제",
  btn_share: "공유",
  btn_close: "닫기",
  
  // 백업 페이지
  backup_title: "백업 및 내보내기",
  backup_subtitle: "소중한 추억들을 안전하게 보관하고 언제든 복원하세요",
  backup_full: "전체 백업",
  backup_full_desc: "모든 데이터를 한 번에 백업",
  backup_full_download: "전체 백업 다운로드",
  backup_memories: "추억 백업",
  backup_memories_desc: "사진과 추억 정보만 백업",
  backup_memories_download: "추억 백업 다운로드",
  backup_settings: "설정 백업",
  backup_settings_desc: "가족 설정과 태그만 백업",
  backup_settings_download: "설정 백업 다운로드",
  backup_restore: "백업 복원",
  backup_restore_desc: "백업 파일을 드래그하거나 클릭하여 선택하세요",
  backup_restore_formats: "지원 형식: JSON, ZIP",
  backup_restore_btn: "백업 복원하기",
  backup_auto: "자동 백업 설정",
  backup_auto_enable: "자동 백업 활성화",
  backup_frequency: "백업 주기",
  backup_daily: "매일",
  backup_weekly: "매주",
  backup_monthly: "매달",
  backup_time: "백업 시간",
  backup_max_count: "최대 백업 개수",
  backup_save_settings: "설정 저장",
  backup_history: "백업 기록",
  
  // 홈페이지
  hero_our_children: "우리 아이들",
  hero_view_memories: "추억 둘러보기", 
  hero_add_memory: "추억 추가하기",
  stat_total_memories: "전체 추억",
  section_our_children: "우리 아이들",
  child_minho_title: "민호",
  child_minho_desc: "우리 집의 든든한 첫째, 민호의 성장 이야기",
  child_minho_view: "민호의 추억 보기",
  child_mina_title: "민아", 
  child_mina_desc: "사랑스러운 막내, 민아의 귀여운 일상",
  child_mina_view: "민아의 추억 보기",
  section_recent_memories: "최근 추억",
  view_all_memories: "모든 추억 보기",
  cta_title: "오늘의 소중한 순간을 기록해보세요",
  cta_desc: "시간이 지나도 빛나는 추억들을 민호민아닷컴에 담아두세요",
  btn_upload_memory: "추억 업로드하기",
  btn_start: "시작하기",
  
  // 업로드 페이지
  upload_title: "새로운 추억 추가",
  upload_edit_title: "추억 수정하기",
  upload_subtitle: "소중한 순간을 영원히 기록하세요",
  upload_edit_subtitle: "소중한 순간을 다시 편집하세요",
  upload_media_label: "사진/동영상 *",
  upload_drag_drop: "여기에 파일을 드래그하거나",
  upload_select_file: "파일 선택",
  upload_file_types: "JPG, PNG, GIF, MP4, MOV (최대 50MB)",
  upload_existing_files: "기존 파일",
  upload_title_label: "제목 *",
  upload_title_placeholder: "추억의 제목을 입력하세요",
  upload_title_required: "제목을 입력해주세요",
  upload_description_label: "설명",
  upload_description_placeholder: "추억에 대한 설명을 입력하세요",
  upload_date_label: "날짜 *",
  upload_date_required: "날짜를 선택해주세요",
  upload_people_label: "함께한 사람",
  upload_add_person: "인물 추가",
  upload_tags_label: "태그",
  upload_add_tag: "태그 추가",
  upload_album_label: "앨범",
  upload_submit: "추억 추가하기",
  upload_edit_submit: "추억 수정하기",
  upload_uploading: "업로드 중...",
  upload_editing: "수정 중...",
  upload_min_one_file: "최소 하나의 사진이나 동영상을 추가해주세요.",
  upload_min_one_media: "최소 하나의 사진이나 동영상은 유지해야 합니다.",
  upload_login_required: "로그인이 필요합니다.",
  upload_error: "업로드 중 오류가 발생했습니다",
  upload_edit_error: "수정 중 오류가 발생했습니다",
  
  // 추억 갤러리 페이지
  memories: {
    title: "추억 갤러리",
    error: "추억을 불러오는 중 오류가 발생했습니다.",
    refresh: "새로고침",
    searchPlaceholder: "추억 검색...",
    count: "개의 추억",
    ageFilter: "나이별 보기",
    all: "전체",
    age: "세",
    filter: "필터",
    personFilter: "인물",
    yearFilter: "연도",
    year: "년",
    tagFilter: "태그",
    filterReset: "필터 초기화",
    photos: "개 사진",
    noResults: "검색 결과가 없습니다.",
    noMemories: "아직 추억이 없습니다.",
    loadingMore: "더 많은 추억을 불러오는 중...",
    allLoaded: "모든 추억을 불러왔습니다",
    deleteConfirmTitle: "추억을 삭제하시겠습니까?",
    deleteConfirmMessage: "를 삭제하면 복구할 수 없습니다.",
    cancel: "취소",
    deleting: "삭제 중...",
    edit: "수정",
    delete: "삭제",
    deleteError: "추억 삭제에 실패했습니다.",
    permissionError: "삭제 권한이 없습니다. 관리자에게 문의하세요.",
    slideshow: "슬라이드쇼",
    share: "공유하기",
    download: "다운로드",
    comments: "댓글",
    backToGallery: "추억 갤러리로 돌아가기",
    notFound: "추억을 찾을 수 없습니다.",
    notFoundDescription: "요청하신 추억이 존재하지 않거나 삭제되었습니다.",
    loadError: "추억을 불러오는 중 오류가 발생했습니다.",
    addToAlbum: "앨범에 추가",
    selectAlbums: "앨범 선택",
    updateError: "추억 업데이트에 실패했습니다."
  },
  
  // 성장 기록 페이지
  growth: {
    title: "성장 기록",
    subtitle: "민호와 민아의 성장 과정을 그래프로 확인해보세요",
    addRecord: "기록 추가",
    currentStatus: "현재 상태",
    recentGrowth: "최근 성장률",
    last3Months: "최근 3개월",
    lastRecord: "마지막 기록",
    height: "키",
    weight: "몸무게",
    heightCm: "키 (cm)",
    weightKg: "몸무게 (kg)",
    growthChart: "성장 차트",
    recordHistory: "성장 기록 내역",
    date: "날짜",
    age: "나이",
    memo: "메모",
    actions: "작업",
    noRecords: "아직 성장 기록이 없습니다.",
    addRecordTitle: "성장 기록 추가",
    person: "인물",
    selectPerson: "선택하세요",
    memoOptional: "메모 (선택)",
    save: "저장",
    saving: "저장 중...",
    cancel: "취소",
    recordAdded: "성장 기록이 추가되었습니다!",
    recordDeleted: "기록이 삭제되었습니다.",
    deleteConfirm: "이 기록을 삭제하시겠습니까?",
    noAgeInfo: "나이 정보 없음",
    years: "세",
    months: "개월",
    daysAgo: "일 전"
  },
  
  // 통계 페이지
  statistics: {
    title: "통계 대시보드",
    totalMemories: "전체 추억",
    photos: "사진",
    videos: "동영상",
    mostActiveMonth: "가장 활발한 달",
    monthlyStats: "월별 추억 통계",
    personStats: "인물별 통계",
    tagCloud: "태그 클라우드",
    memoryCount: "추억 수",
    noData: "아직 데이터가 없습니다",
    noTags: "아직 태그가 없습니다",
    noneYet: "아직 없음"
  },
  
  // 앨범 페이지
  albums: {
    title: "앨범",
    newAlbum: "새 앨범",
    noAlbums: "아직 앨범이 없습니다",
    createFirst: "첫 번째 앨범을 만들어보세요!",
    memoriesCount: "개의 추억",
    createAlbum: "앨범 만들기",
    albumName: "앨범 이름",
    albumNamePlaceholder: "예: 2024년 가족 여행",
    description: "설명",
    descriptionPlaceholder: "이 앨범에 대한 설명을 입력하세요",
    makePublic: "공개 앨범으로 설정",
    create: "만들기",
    creating: "만드는 중...",
    cancel: "취소",
    backToAlbums: "앨범 목록으로 돌아가기",
    notFound: "앨범을 찾을 수 없습니다",
    noMemories: "이 앨범에 추억이 없습니다",
    addMemoriesDesc: "추억 갤러리에서 이 앨범에 추가할 수 있습니다",
    addMemories: "추억 추가하기",
    editAlbum: "앨범 수정",
    save: "저장",
    saving: "저장 중...",
    deleteAlbum: "앨범 삭제",
    deleteConfirm: "이 앨범을 삭제하시겠습니까? 앨범 안의 추억들은 삭제되지 않습니다.",
    delete: "삭제",
    deleting: "삭제 중...",
    updateError: "앨범 업데이트에 실패했습니다.",
    setCover: "앨범 커버로 설정"
  },
  
  // 포토북 만들기 페이지
  photobook: {
    title: "포토북 만들기",
    subtitle: "소중한 추억들을 멋진 포토북으로 만들어보세요",
    settings: "포토북 설정",
    template_selection: "템플릿 선택",
    template_classic: "클래식",
    template_classic_desc: "우아하고 정통적인 디자인",
    template_modern: "모던",
    template_modern_desc: "현대적이고 세련된 레이아웃",
    template_minimal: "미니멀",
    template_minimal_desc: "깔끔하고 단순한 스타일",
    period_to_include: "포함할 기간",
    start_date: "시작 날짜",
    end_date: "종료 날짜",
    options: "옵션",
    include_cover_page: "표지 페이지 포함",
    include_stats_page: "통계 페이지 포함",
    include_index_page: "목차 페이지 포함",
    include_timeline: "타임라인 포함",
    people_to_include: "포함할 인물",
    all: "전체",
    minho_only: "민호만",
    mina_only: "민아만",
    minho_mina_together: "민호민아 함께",
    preview: "미리보기",
    generate_photobook: "포토북 생성",
    photobook_preview: "포토북 미리보기",
    creating_photobook: "포토북 생성 중...",
    preparing: "사진을 준비하고 있습니다..."
  },
  
  // 활동 로그 페이지
  activityLog: {
    title: "활동 로그",
    export: "내보내기",
    allActivities: "모든 활동",
    create: "생성",
    update: "수정",
    delete: "삭제",
    share: "공유",
    noActivities: "활동 기록이 없습니다",
    noActivitiesDesc: "추억을 추가하거나 수정하면 여기에 기록됩니다.",
    action_create: "새로운 추억을 추가했습니다",
    action_update: "추억을 수정했습니다",
    action_delete: "추억을 삭제했습니다",
    action_restore: "추억을 복원했습니다",
    action_share: "추억을 공유했습니다",
    action_download: "추억을 다운로드했습니다"
  },
  
  // 휴지통 페이지
  trash: {
    title: "휴지통",
    auto_delete_notice: "휴지통의 항목은 30일 후 자동으로 영구 삭제됩니다.",
    select_all: "모두 선택",
    deselect_all: "선택 해제",
    selected_count: "개 선택됨",
    restore: "복원",
    delete_permanently: "영구 삭제",
    empty_title: "휴지통이 비어있습니다",
    empty_desc: "삭제된 항목이 여기에 표시됩니다.",
    deleted_date: "삭제일",
    permanent_delete_days: "일 후 영구 삭제",
    confirm_permanent_delete: "선택한 항목을 영구적으로 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다."
  },
  
  // 프로필 페이지
  profile: {
    title: "내 프로필",
    loading_error: "프로필을 불러오는 중 오류가 발생했습니다.",
    not_found: "프로필을 찾을 수 없습니다.",
    update_success: "프로필이 업데이트되었습니다.",
    update_error: "프로필 업데이트 중 오류가 발생했습니다.",
    basic_info: "기본 정보",
    email: "이메일",
    username: "사용자명",
    username_placeholder: "사용자명 입력",
    full_name: "이름",
    full_name_placeholder: "이름 입력",
    not_set: "설정되지 않음",
    role: "역할",
    role_parent: "부모",
    role_family: "가족",
    role_viewer: "방문자",
    role_parent_desc: "모든 기능에 접근할 수 있습니다.",
    role_family_desc: "추억을 보고 댓글을 달 수 있습니다.",
    role_viewer_desc: "추억을 볼 수만 있습니다.",
    cancel: "취소",
    save: "저장",
    saving: "저장 중...",
    account_info: "계정 정보",
    joined_date: "가입일",
    last_updated: "마지막 수정"
  },

  // 관리자 페이지
  admin: {
    title: "관리자 페이지",
    subtitle: "사용자 관리 및 시스템 활동을 모니터링합니다.",
    accessDenied: "접근 권한이 없습니다",
    accessDeniedDesc: "이 페이지는 관리자(parent)만 접근할 수 있습니다.",
    userManagement: "사용자 관리",
    activityLog: "활동 로그",
    loading: "로딩 중...",
    user: "사용자",
    email: "이메일",
    role: "역할",
    joinedDate: "가입일",
    actions: "작업",
    edit: "편집",
    roleBadge: {
      parent: "관리자",
      family: "가족",
      viewer: "일반"
    },
    updateRole: "역할 변경",
    updating: "변경 중...",
    roleUpdated: "사용자 역할이 업데이트되었습니다.",
    roleUpdateFailed: "역할 업데이트 실패",
    profileModal: {
      title: "프로필 편집",
      email: "이메일",
      username: "사용자명",
      fullName: "이름",
      save: "저장",
      cancel: "취소",
      saving: "저장 중...",
      updated: "프로필이 업데이트되었습니다.",
      updateFailed: "프로필 업데이트 실패"
    },
    activity: {
      action: "작업",
      created: "생성",
      updated: "수정",
      deleted: "삭제",
      details: "상세 정보",
      date: "날짜",
      noData: "활동 로그가 없습니다."
    },
    unknown: "알 수 없음",
    notSet: "설정 안 됨",
    ago: "전",
    tagManagement: "태그 관리",
    peopleManagement: "인물 관리",
    tags: {
      name: "태그명",
      usageCount: "사용 횟수",
      memories: "개 추억",
      deleted: "태그가 삭제되었습니다.",
      deleteFailed: "태그 삭제에 실패했습니다.",
      deleteConfirm: "이 태그를 삭제하시겠습니까?",
      deleteConfirmWithUsage: "이 태그는 {{count}}개의 추억에서 사용 중입니다. 정말 삭제하시겠습니까?"
    },
    people: {
      name: "이름",
      usageCount: "사용 횟수",
      memories: "개 추억",
      birthdate: "생년월일",
      deleted: "인물이 삭제되었습니다.",
      deleteFailed: "인물 삭제에 실패했습니다.",
      deleteConfirm: "이 인물을 삭제하시겠습니까?",
      deleteConfirmWithUsage: "이 인물은 {{count}}개의 추억에서 사용 중입니다. 정말 삭제하시겠습니까?"
    }
  }
} as const;

export type TranslationKeys = keyof typeof ko;